export default function PHP_foreach() {
  return (
    <div>
      <h1>PHP_foreach</h1>
    </div>
  );
}
